"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoBillPayState = void 0;
var AutoBillPayState = /** @class */ (function () {
    function AutoBillPayState() {
        this.isExpandedView = false;
    }
    return AutoBillPayState;
}());
exports.AutoBillPayState = AutoBillPayState;
//# sourceMappingURL=AutoBillPayState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/AutoBillPay/AutoBillPayState.js
// module id = 2301
// module chunks = 8